module.exports = __webpack_public_path__ + "static/media/poll.ddc33b69.svg";